module.exports = __webpack_public_path__ + "static/fetch-ruffcut-helga-c9044fe3860b2b06d9f734d00aa60304.webm";